export const DuplicatedCodeSuffix = 'COPY';
